<!--订单管理-->
<template>
  <div id="order-management" ref="view">
    <div class="headbar">
      <el-form ref="searchParams" :model="searchParams" label-width="80px" inline>
        <el-form-item label="运单号">
          <el-input v-model.trim="searchParams.trackingNo" size="normal" placeholder="请输入运单号" @keyup.enter.native="handleSearch" ></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model.trim="searchParams.customerNo" size="normal" placeholder="请输入订单号" @keyup.enter.native="handleSearch" ></el-input>
        </el-form-item>
        <el-form-item label="客户名">
          <el-input v-model.trim="searchParams.customerName" size="normal" placeholder="请输入搜索的客户名" @keyup.enter.native="handleSearch" ></el-input>
        </el-form-item>
        <el-form-item label="创建日期">
          <el-date-picker v-model="searchParams.create_time_start" style="width: 140px"
            ref="ds" @change="onChangeDateS" type="date" size="small"
            :picker-options="dateOptionStart()" value-format="yyyy-MM-dd"
            placeholder="开始时间" />
          <span class="label" style="margin: 0 5px;">-</span>
          <el-date-picker v-model="searchParams.create_time_end" style="width: 140px; margin-right:15px;"
            ref="de" @change="onChangeDateE" :picker-options="dateOptionEnd()"
            value-format="yyyy-MM-dd" type="date" size="small" placeholder="结束时间"
          />
         </el-form-item>
        <el-form-item>
          <el-button class="mr" type="primary" size="small"
            @click="clearSearch">重置</el-button>
          <el-button class="mr" type="primary" size="small"
            @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>

      <div class="filter-bar">

      </div>

      <el-button class="fr" type="primary" size="small" v-permission="'1-1-1'" @click="handleAdd">新增</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%" v-loading="loading"
      :height="tableHeight">
      <el-table-column label="序号" type="index" :index="indexMethod"
        width="60" />
      <template v-for="item in tableColumns">
        <el-table-column v-if="item.prop == 'order_time'" :key="item.prop"
          :prop="item.prop" :label="item.label" :min-width="item.width"
          :class-name="item.class">
        </el-table-column>
        <el-table-column v-else :key="item.prop" :prop="item.prop" :label="item.label"
          :width="item.width" :class-name="item.class">
        </el-table-column>
      </template>

      <el-table-column label="操作" min-width="250">
        <template slot-scope="scope">
          <el-button size="mini" type="success" plain v-permission="'1-1-2'" @click="handleDetail(scope.row)">详情</el-button>
          <el-button  size="mini" type="primary" plain v-permission="'1-1-4'" @click="showLogis(scope.row)">物流信息</el-button>
          <el-button  size="mini" type="danger" plain v-permission="'1-1-5'" @click="handleDelete(scope.row)">删除</el-button>
          <!-- <el-button v-if="scope.row.order_status == 2 || scope.row.order_status == 6"
            size="mini" type="primary" plain v-permission="'2-1-4'" @click="changeStatus(scope.row, 5)">终止</el-button> -->
          <!-- <el-button v-if="scope.row.order_status == 2 || scope.row.order_status == 6" size="mini" type="danger"
            plain v-permission="'2-1-4'" @click="changeStatus(scope.row, 3)">签收</el-button> -->
          <!-- <el-button v-if="scope.row.order_status == 6" size="mini" type="primary"
            plain v-permission="'2-1-4'" @click="changeStatus(scope.row, 1)">入库</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" background layout="prev, pager, next"
      :current-page.sync="current" @current-change="handleChangePage"
      :total="total">></el-pagination>
    <el-dialog :title="editData.customerNo?`${editing?'编辑订单':'订单详情'} (${editData.customerNo})`:'新增订单'"
      :visible.sync="modalEdit" :append-to-body="true" custom-class="hd-dialog"
      :loading="loadingDetail"
      width="1300px"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <OrderDetail v-if="!loadingDetail && modalEdit" ref="form" :orderData="editData" :editDataCopy="editDataCopy" :editing="editing"
      />
      <span slot="footer">
        <template v-if="editing">
          <el-button size="mini" @click="cancelEdit">取 消</el-button>
          <el-button size="mini" type="primary" @click="doEdit">提 交</el-button>
        </template>
        <template v-else>
          <el-button size="mini" v-permission="'1-1-3'" type="primary" :disabled="false"
            @click="handleEdit">编 辑</el-button>
          <el-button size="mini" type="normal" @click="modalEdit = false">关 闭</el-button>
        </template>
      </span>
    </el-dialog>
    <el-dialog title="物流信息"
      :visible.sync="modalLogis" :append-to-body="true" custom-class="hd-dialog" :close-on-click-modal="false"
      width="1200px">
      <div class="logis-comment">
        <p>订单号：{{ editData.customerNo }}</p>
        <p>跟踪号：{{ editData.trackingNo }}</p>
        <ul class="logis-ul" v-for="(item,index) in logisInfo" :key="index">
          <li><span>位置:</span>{{item.trackingLocation}}</li>
          <li><span>时间:</span>{{dateFormate(item.trackingTime)}}</li>
          <li><span>描述:</span>{{item.trackingDesc}}</li>
        </ul>
      </div>
      <!-- <LYForm style="width: 100%" v-if="modalLogis" :formData="logisInfo"
        :displayData="formConfig()"
        :opts="defaultOpts()" /> -->
      <span slot="footer">
      <template>
          <el-button size="mini" type="primary" @click="modalLogis = false">关 闭</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { orderApi } from '@/service'
import LYForm from '@/pages/components/ly-form'
import OrderDetail from './order-detail'
import moment from 'moment';
export default {
  name: 'orderManagement',
  components: {
    LYForm,
    OrderDetail
  },
  data() {
    return {
      logisInfo:[],
      modalLogis:false,
      // defaultOpts: () => {
      //   return {
      //     defaultLabel: 90,
      //     defaultSpan: 23,
      //     defaultOffset: 1,
      //     labelPosition: 'left'
      //   }
      // },
      // formConfig: () => [
      //   { label: '运单号:', type: 'input', prop: 'trackingNo', disabled: !this.editing },
      //   { label: '状态码:', type: 'input', prop: 'trackingCode', disabled: !this.editing },
      //   { label: '当前位置:', type: 'textArea', prop: 'trackingLocation',  disabled: !this.editing },
      //   { label: '时间点:', type: 'input', prop: 'trackingTime',  disabled: !this.editing,},
      //   { label: '描述:', type: 'textArea', prop: 'trackingDesc',  disabled: !this.editing,},
      // ],
      loading: false,
      loadingDetail: false,
      modalEdit: false,
      editData: {},
      editDataCopy: {},
      editing: false,
      searchValue: '',
      searchParams: {
        trackingNo: '',
        customerNo: '',
        customer_name:'',
        create_time_start: '',
        create_time_end: '',
      },
      changingDate: false,

      orderStatusOpts: [
        { value: 1, label: '已入库' },
        { value: 2, label: '运输中' },
        { value: 3, label: '已签收' },
        { value: 4, label: '已完成' },
        { value: 5, label: '已终止' },
        { value: 6, label: '异常' },
      ],
      goodTypesOpts: [],
      channelsOps: [],
      salesmanOpts:[],
      servicesOpts:[],
      operatorsOpts:[],
      auditorsOpts: [],
      tableColumns: [
        { label: '跟踪号', prop: 'trackingNo', width: 180 },
        { label: '订单号', prop: 'customerNo', width: 180 },
        { label: '包裹数量', prop: 'packageQuantity', width: 120 },
        { label: '总重量(kg)', prop: 'totalWeight', width: 120 },
        { label: '总体积(m³)', prop: 'totalVolume', width: 120 },
        { label: 'COD金额', prop: 'codAmount', width: 120 },
        { label: '订单金额', prop: 'orderAmount', width: 120 },
        { label: 'COD币种', prop: 'currency', width: 100 },
        { label: '发件人名称', prop: 'sender', width: 110 },
        { label: '收人名称', prop: 'receiver', width: 110 },
        { label: '创建时间', prop: 'create_time', width: 150 },
      ],
      dateOptionStart: () => {
        let this_ = this
        return {
          disabledDate(c) {
            let a = c.getTime() < Date.now(); // - 3600 * 1000 * 24;
            let b = this_.searchParams.create_time_end ? c.getTime() < new Date(this_.searchParams.create_time_end).getTime() : true
            return !(a && b)
          },
        }
      },
      dateOptionEnd: () => {
        let this_ = this
        return {
          disabledDate(c) {
            return !(this_.searchParams.create_time_start ? c.getTime() > new Date(this_.searchParams.create_time_start).getTime() - 3600 * 24 * 1000 : true)
          },
        }
      },
      tableHeight: 500,

      current: 1,
      total: 0,

      tableData: [],
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.fetchData()
    this.bindWindowResize.bind(this)
    window.addEventListener("resize", this.bindWindowResize);
    setTimeout(() => {
      this.initTableHeight()
    }, 200)
  },
  created() { },
  destroyed() {
    window.removeEventListener('resize', this.bindWindowResize)
  },
  methods: {
    //日期格式化：
    dateFormate(time) {
      return moment(time).format('YYYY-MM-DD HH:mm')
    },
    //开始日期范围改变
    onChangeDateS() {
      this.changingDate = true
      this.$refs.de.focus()
    },
    onChangeDateE() {
      this.changingDate = false
      this.fetchData()
    },
    bindWindowResize() {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.initTableHeight();
        this.timer = null;
      }, 200);
    },
    initTableHeight() {
      this.tableHeight = this.$refs.view.clientHeight - 100
    },
    indexMethod(index) {
      return index + 1 + (this.current - 1) * 10
    },
    initialEditData() {
      return {
      totalWeight: 0, // 总重量,单位kg
      totalVolume: 0, // 总体积,单位m³(保留四位小数)
      isCod: false, // 是否是Cod订单，默认值为 false
      packageQuantity: 1, // 包裹数量，默认值为1
      codAmount: 0, // COD金额，默认值为0
      orderAmount: 0, // 订单金额，默认值为0
      currency: "SAR", // COD币种，默认值为 SAR
      ifpickup: false, // 是否自提，默认值为 false
      name:'',
      phone:'',
      region:[],
      address:'',
      receiver_name:'',
      receiver_region:[],
      receiver_address:'',
      goods: [],

      }
    },
    clearSearch(){
      this.searchParams = {
        trackingNo:'',
        customerNo:'',
        customer_name:'',
        create_time_start:'',
        create_time_end:''
      }
    },
    handleSearch() {
      this.fetchData()
    },
    handleAdd() {
      this.modalEdit = true;
      this.editing = true
      this.editData = this.initialEditData()
    },
    handleDetail(row) {
      this.editing = false;
      this.modalEdit = true;
      this.fetchDetail(row.id)
    },
    // changeStatus(row, status) {
    //   this.$confirm('操作确认?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     orderApi.updateStatus(row.id, { status }).then(res => {
    //       this.$msg({
    //         type: 'success',
    //         message: '操作成功'
    //       })
    //       this.fetchData()
    //     })
    //   }).catch(() => {
    //   });
    // },
    handleEdit() {
      this.editing = true
    },
    //选择地区
    // handleChangeRegion(regions){
    //   switch(regions.length){
    //     case 1:
    //       this.regionObj.countryId = regions[0];
    //     break;
    //     case 2:
    //       this.regionObj.countryId = regions[0];
    //       this.regionObj.stateId = regions[1];
    //     break;
    //     case 3:
    //       this.regionObj.countryId = regions[0];
    //       this.regionObj.stateId = regions[1];
    //       this.regionObj.cityId = regions[2];
    //     break;
    //     case 4:
    //       this.regionObj.countryId = regions[0];
    //       this.regionObj.stateId = regions[1];
    //       this.regionObj.cityId = regions[2];
    //       this.regionObj.distinctId = regions[3];
    //     break;
    //     default:
    //       this.regionObj.countryId = regions[0];
    //       this.regionObj.stateId = regions[1];
    //       this.regionObj.cityId = regions[2];
    //       this.regionObj.distinctId = regions[3];
    //     break;
    //   }
    // },
    async doEdit() {
      let count = -1
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.editData.id) {
        let submitData = JSON.parse(JSON.stringify(this.$refs.form.orderData))
        // submitData.goods.splice(submitData.goods.length-1,1);
        orderApi.update(this.editData.id, submitData
        ).then(() => {
          this.fetchData()
          this.$msg({
            type: 'success',
            message: '更新成功'
          })
          this.modalEdit = false
        })
      } else {
        orderApi.create(this.editData).then(() => {
          this.fetchData()
          this.$msg({
            type: 'success',
            message: '新增成功'
          })
        })
        this.modalEdit = false
      }
    },
    cancelEdit() {
      this.editing = false
      if (this.editData.order_code) {
        this.editData = JSON.parse(JSON.stringify(this.editDataCopy))
      } else {
        this.modalEdit = false
      }
    },
    handleChangePage(v) {
      this.current = v
      this.fetchData()
    },
    showLogis(row) {
      this.editData = row
      let trackingNo = row.trackingNo;
      let params = {trackingNo:trackingNo};
      orderApi.parcelLogistic(
        params
      ).then(res => {
        if(res.data.results){
          this.logisInfo = res.data.results;
          this.modalLogis = true
        }else{
           this.$msg({
            type: 'warning',
            message: res.massage || '获取物流信息失败'
          })
          this.logisInfo = [];
          this.modalLogis = false
        }
      }).catch(() => {
        this.logisInfo = [];
        this.$msg({
          type: 'warning',
          message: '获取物流信息失败'
        })
        this.modalLogis = false
      })
    },
    fetchDetail(id) {
      this.loadingDetail = true
      orderApi.detail(id
      ).then(res => {
        this.loadingDetail = false
         // 对发货发方信息进行转换
        res.data.name = res.data.sender.name
        res.data.phone = res.data.sender.phone
        res.data.region = res.data.sender.region
        res.data.address = res.data.sender.address
        res.data.sender = res.data.sender.id;
        // 对收货发方信息进行转换
        res.data.receiver_name = res.data.receiver.name
        res.data.receiver_phone = res.data.receiver.phone
        res.data.receiver_region = res.data.receiver.region
        res.data.receiver_address = res.data.receiver.address
        res.data.receiver = res.data.receiver.id;
        this.editData = res.data;
        this.editDataCopy = JSON.parse(JSON.stringify(this.editData));

      }).catch(() => {
        this.loadingDetail = false
        this.$msg({
          type: 'warning',
          message: '获取订单详情失败'
        })
        this.modalEdit = false
        this.loadingDetail = false
      })
    },
    fetchData() {
      this.loading = true
      orderApi.list({
        ...this.searchParams,
        page: this.current,
        pagesize: 10
      }).then(res => {
        this.loading = false
        this.current = res.page.page
        this.total = res.page.count
        this.tableData = res.data
      }).catch(() => {
        this.loading = false
      })
    },
    handleDelete(row) {
      this.$confirm('删除确认?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderApi.delete(row.id).then(res => {
          this.$msg({
            type: 'success',
            message: '操作成功',
          })
          this.fetchData()
        })
      }).catch(() => {
      })
    },
  },
};
</script>

<style lang="less">
#order-management {
  height: 100%;
  .pagination {
    margin-top: 10px;
    float: right;
  }
  .search-btn {
    border: solid 1px #409eff;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .filter-bar {
    padding: 5px;
    display: inline-block;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}
.logis-comment{
  width:100%;
  padding:15px;
  max-height:500px;
  height:100%;
  .logis-ul{
    padding:10px;
    margin-top:15px;
    border:1px dotted blue;
    li{
      width:30%;
      display: inline-block;
      span{
        display: inline-block;
        width:90px;
        height:30px;
        line-height:30px;
      }
      margin-right:15px;
    }
  }
}
</style>
